(function () {
    let bootstrapPromise = null;

    function bootstrapGoogleMaps(apiKey) {
        if (bootstrapPromise) return bootstrapPromise;

        bootstrapPromise = new Promise((resolve, reject) => {
            (g => {
                var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
                b = b[c] || (b[c] = {});
                var d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(),
                    u = () => h || (h = new Promise(async (f, n) => {
                        await (a = m.createElement("script"));
                        e.set("libraries", [...r] + "");
                        for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
                        d[q] = f;
                        a.onerror = () => h = n(Error(p + " could not load."));
                        a.nonce = m.querySelector("script[nonce]")?.nonce || "";
                        m.head.append(a);
                    }));
                d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
            })({ key: apiKey, v: "weekly" });

            window.google.maps.importLibrary("maps").then(resolve).catch(reject);
        });

        return bootstrapPromise;
    }

    function renderMap(el, apiKey) {
        const lat = parseFloat(el.dataset.lat);
        const lng = parseFloat(el.dataset.lng);
        const zoom = parseInt(el.dataset.zoom || '15', 10);
        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        bootstrapGoogleMaps(apiKey).then(() => {
            const map = new window.google.maps.Map(el, { center: { lat, lng }, zoom });
            new window.google.maps.Marker({ position: { lat, lng }, map });
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        const mapEls = document.querySelectorAll('.js-google-map');
        if (!mapEls.length) return;

        if (!('IntersectionObserver' in window)) {
            mapEls.forEach((el) => {
                if (el.dataset.apiKey) renderMap(el, el.dataset.apiKey);
            });
            return;
        }

        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                obs.unobserve(entry.target);
                const apiKey = entry.target.dataset.apiKey;
                if (apiKey) renderMap(entry.target, apiKey);
            });
        }, { rootMargin: '200px' });

        mapEls.forEach((el) => observer.observe(el));
    });
})();
